/** Which app this page is (ADR 0013): `accounts.` signs in, `console.` is the platform console,
 *  `control.` the organizations. `single`: one host serves everything (development on
 *  `localhost`, installations without the three hosts). */
export type HostRole = 'accounts' | 'console' | 'control' | 'single';
export type AppHost = Exclude<HostRole, 'single'>;

const withoutTrailingSlash = (url: string | undefined) => (url ?? '').trim().replace(/\/+$/, '');

const HOSTS: Record<AppHost, string> = {
  accounts: withoutTrailingSlash(import.meta.env.VITE_ACCOUNTS_URL),
  console: withoutTrailingSlash(import.meta.env.VITE_CONSOLE_URL),
  control: withoutTrailingSlash(import.meta.env.VITE_CONTROL_URL),
};

/** The role of the current origin; an origin that is none of the three is `single`. */
export function hostRole(origin: string = window.location.origin): HostRole {
  const match = (Object.keys(HOSTS) as AppHost[]).find(
    (key) => HOSTS[key] !== '' && HOSTS[key] === origin,
  );
  return match ?? 'single';
}

export function hostUrl(host: AppHost): string {
  return HOSTS[host];
}

/** What to open on `control.`: an organization, or a support window. */
export interface HostTarget {
  organizationId?: string | undefined;
  grantId?: string | undefined;
}

/** Opens the target app: it makes its own verifier and comes back through `accounts.`. */
export function goToHost(host: 'console' | 'control', target: HostTarget = {}): void {
  const query = new URLSearchParams({
    ...(target.organizationId === undefined ? {} : { org: target.organizationId }),
    ...(target.grantId === undefined ? {} : { grant: target.grantId }),
  }).toString();
  window.location.assign(`${hostUrl(host)}/auth/start${query === '' ? '' : `?${query}`}`);
}
